
$(document).ready(function() {
    // Különbség megállapítása asztali és mobil eszközök között.
    // Ezt egyszerűen hover képesség vizsgálatával is megtehetjük, vagy más detektálási módszert használhatunk.
    var isTouchDevice = 'ontouchstart' in document.documentElement;
  
    if (isTouchDevice) {
        // Mobil eszközökön a click eseményre reagálunk.
        $('[mega-menu-id]').click(function(e) {
            // Megelőzzük az alapértelmezett működést, ha szükséges.
            e.preventDefault();
            $('.sub-mega').removeClass('active');
            var megaMenuId = $(this).attr('mega-menu-id');
            $('.'+megaMenuId).toggleClass('active');
        });
    } else {
        // Asztali eszközökön a hover eseményre reagálunk.
        $('[mega-menu-id]').mouseenter(function() {
            $('.sub-mega').removeClass('active');
            var megaMenuId = $(this).attr('mega-menu-id');
            $('.'+megaMenuId).addClass('active');
        });
        
        $('.sub-mega').mouseleave(function() {
            $(this).removeClass('active');
        });
    }
});


$(document).ready(function(){
    $(window).scroll(function(){
        var scroll = $(window).scrollTop();
        if (scroll > 0) {
            $(".mega-menu").addClass("scrolled");
        } else {
            $(".mega-menu").removeClass("scrolled");
        }
    }); 
});

$(document).ready(function(){
    $(".mobil-filter").click(function(){
        $(".mobil-screen").toggleClass("active");
    });
});
